import type { MaskedPlayer as Player } from '@completto/shared';
import { html, View } from 'rune-ts';
import { OpponentCardView } from './OpponentCard.ts';

export type OpponentPanelData = {
  players: readonly Player[];
  currentPlayerIdx: number;
  myPlayerId: string;
  recentlyActedId: string | null;
};

export class OpponentPanelView extends View<OpponentPanelData> {
  override template() {
    const { players, currentPlayerIdx, myPlayerId, recentlyActedId } = this.data;
    // 본인 제외 — opponent panel은 의미상 "상대만". 본인 진행도는 MyLane 헤더에 이미 있음.
    const opponents = players
      .map((p, i) => ({ player: p, idx: i }))
      .filter(({ player }) => player.id !== myPlayerId);

    const cards = opponents.map(
      ({ player, idx }, displayIdx) =>
        new OpponentCardView({
          player,
          isCurrentTurn: idx === currentPlayerIdx,
          isMe: false,
          recentlyActed: player.id === recentlyActedId,
          seatLabel: displayIdx + 1,
        }),
    );

    // 가로 + 빈 패널(싱글 모드 등)이면 panel 자체 hidden — 화면 공간 회수.
    const hideIfEmpty = opponents.length === 0 ? 'mlandscape:hidden' : '';

    return html`
      <aside class="opponent-panel flex flex-col gap-2 mlandscape:gap-1 mlandscape:overflow-y-auto mlandscape:px-1 mlandscape:py-1 ${hideIfEmpty}">
        <div class="flex items-baseline justify-between px-1 mlandscape:hidden">
          <span class="text-caption uppercase tracking-widest text-wood-coffee/70">OPPONENTS</span>
          <span class="text-caption text-wood-coffee/55 tabular-nums">${opponents.length}</span>
        </div>
        ${cards}
      </aside>
    `;
  }
}
